import http from './client';

/**
 * Tag OpenAPI: Auth
 * POST /change-password — requiere JWT (Authorization).
 * POST /forgot-password, POST /reset-password — públicos (sin JWT).
 */

/**
 * @param {{ current_password: string, new_password: string }} body
 * @returns {Promise<import('axios').AxiosResponse<{ message?: string }>>}
 */
export function changePassword(body) {
  return http.post('/change-password', body);
}

/**
 * @param {{ email: string }} body
 * @returns {Promise<import('axios').AxiosResponse<{ message?: string }>>}
 */
export function forgotPassword(body) {
  return http.post('/forgot-password', body);
}

/**
 * @param {{ token: string, new_password: string }} body
 * @returns {Promise<import('axios').AxiosResponse<{ message?: string }>>}
 */
export function resetPasswordWithToken(body) {
  return http.post('/reset-password', body);
}
